import { Component, inject, OnInit, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AvatarModule } from 'primeng/avatar';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { PerfilService } from '@/services/perfil.service';
import { UserPhotoService } from '@/services/user-photo.service';
import { AuthService } from '@/services/auth.service';
import { UsuarioResponse } from '@/models/usuario.model';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AvatarModule, AppConfigurator],
    template: ` <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <a class="layout-topbar-logo" routerLink="/">
                <span>IEQ Manager</span>
            </a>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                </button>

                <div class="layout-topbar-nome-container">
                    <span class="layout-topbar-nome">Olá, {{ usuario()?.nomeCompleto }}</span>
                </div>

                <!--                <div class="relative">-->
                <!--                    <button-->
                <!--                        class="layout-topbar-action layout-topbar-action-highlight"-->
                <!--                        pStyleClass="@next"-->
                <!--                        enterFromClass="hidden"-->
                <!--                        enterActiveClass="animate-scalein"-->
                <!--                        leaveToClass="hidden"-->
                <!--                        leaveActiveClass="animate-fadeout"-->
                <!--                        [hideOnOutsideClick]="true"-->
                <!--                    >-->
                <!--                        <i class="pi pi-palette"></i>-->
                <!--                    </button>-->
                <!--                    <app-configurator />-->
                <!--                </div>-->
            </div>

            <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    <!--button type="button" class="layout-topbar-action">
                        <i class="pi pi-inbox"></i>
                        <span>Messages</span>
                    </button -->
                    <button type="button" class="layout-topbar-action profile-button" (click)="goToProfile()" style="padding: 0.5rem;">
                        @if (usuario()?.urlImgUsuario) {
                            <img [src]="usuario()!.urlImgUsuario" alt="Foto de Perfil" style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover; border: 2px solid var(--primary-color);" />
                        } @else {
                            <p-avatar icon="pi pi-user" size="normal" shape="circle" [style]="{ width: '32px', height: '32px', 'font-size': '1.2rem', border: '2px solid var(--primary-color)' }"> </p-avatar>
                        }
                    </button>
                    <button type="button" class="layout-topbar-action" (click)="logout()">
                        <i class="pi pi-sign-out"></i>
                        <span>Sair</span>
                    </button>
                </div>
            </div>
        </div>
    </div>`
})
export class AppTopbar implements OnInit {
    items!: MenuItem[];

    private readonly router = inject(Router);
    private readonly perfilService = inject(PerfilService);
    private readonly userPhotoService = inject(UserPhotoService);
    private readonly authService = inject(AuthService);
    public layoutService = inject(LayoutService);

    protected readonly usuario = signal<UsuarioResponse | null>(null);

    ngOnInit(): void {
        this.loadUsuario();

        // Escutar notificações de atualização de foto
        this.userPhotoService.photoUpdated$.subscribe(() => {
            this.loadUsuario();
        });
    }

    loadUsuario(): void {
        this.perfilService.getPerfil().subscribe({
            next: (data) => {
                this.usuario.set(data);
            },
            error: (error) => {
                console.error('Erro ao carregar perfil do usuário:', error);
            }
        });
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    goToProfile() {
        this.router.navigate(['/pages/perfil']);
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/auth/login']);
    }
}
